import React, { useEffect, useRef, useState } from 'react';
import styles from './pdf-styles.module.scss';
import { renderPage } from './Previews';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { getExtensionImage } from './extensionMapping';
import { getFileSize } from '../../../utils/format';

export const PdfThumb = function ({ docBlob }) {
  const pdfContainerRef = useRef();
  useEffect(() => {
    (async () => {
      if (docBlob && pdfContainerRef.current) {
        pdfContainerRef.current.innerHTML = '';
        const PDFJS = await import('pdfjs-dist');
        const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
        await import('pdfjs-dist/web/pdf_viewer.css');
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        const url = window.URL.createObjectURL(docBlob);
        const res = await PDFJS.getDocument(url).promise;

        res
          .getPage(1)
          .then((page) =>
            renderPage(
              page,
              1,
              pdfContainerRef.current,
              styles.pdfThumbClassName,
              styles.imageContainer,
            ),
          );
      }
    })();
  }, [docBlob, pdfContainerRef.current]);

  return <div ref={pdfContainerRef} style={{ width: '100%', height: '100%' }} />;
};
export const ImageThumb = function ({ imageData }) {
  const [imageSrc, setImageSrc] = useState(null);
  useEffect(() => {
    setImageSrc(window.URL.createObjectURL(imageData));
  }, [imageData]);

  return <img style={{ maxHeight: '100%', maxWidth: '100%' }} src={imageSrc} />;
};

export function DefaultThumb() {
  return <div />;
}

export const ThumbComponentM = React.memo(function ThumbComponent({ fileBlob, isActive }) {
  const documentType = get(fileBlob, 'type', '');

  function ThumbComponentImpl() {
    if (documentType.match(/.*?(pdf)$/gi)) {
      return <PdfThumb docBlob={fileBlob} />;
    } else if (documentType.match(/.*?(jpg|jpeg|png|bmp|gif)$/gi)) {
      return <ImageThumb imageData={fileBlob} />;
    }
    return <DefaultThumb fileType={fileBlob.type} />;
  }

  return (
    <>
      <ThumbComponentImpl />
      <div className={styles.extensionBar}>
        <div className="Caption white">{getFileSize(fileBlob.size).label}</div>
        {getExtensionImage(fileBlob.type)}
      </div>
      {!isActive && <div className={styles.inactiveShadow} />}
    </>
  );
});

PdfThumb.propTypes = {
  docBlob: PropTypes.any,
};

ImageThumb.propTypes = {
  imageData: PropTypes.any,
};

ThumbComponentM.propTypes = {
  fileBlob: PropTypes.any,
  isActive: PropTypes.bool,
};

DefaultThumb.propTypes = {
  fileType: PropTypes.any,
};
